// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__p6SrX","pageContent":"Layout_pageContent__04p+k","hr":"Layout_hr__hL-yd"};